<!--工单管理-->
<template>
  <div class="container">
    <div class="content-wrapper">
      <div class="page-header">
        <h1>工单管理</h1>
      </div>

      <!-- 搜索区域 -->
      <div class="search-card">
        <el-form :model="searchField" :inline="true" class="search-form">
          <el-form-item label="单号">
            <el-input
                v-model="searchField.order_number"
                placeholder="请输入单号"
                clearable
                style="width: 200px"
                @input="handleSearch"
            />
          </el-form-item>
          <el-form-item label="状态">
            <el-select
                v-model="searchField.status_type"
                placeholder="请选择状态"
                clearable
                style="width: 150px"
                @change="getOrder"
            >
              <el-option
                  v-for="item in statusForm"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">搜索</el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 表格区域 -->
      <div class="table-card">
        <el-table
            :data="orders.data"
            stripe
            style="width: 100%"
            v-loading="loading"
        >
          <el-table-column prop="order_number" label="工单号" width="180"/>
          <el-table-column label="产品名称">
            <template #default="scope">
              {{ scope.row.service_device.brand_name + '-' + scope.row.service_device.model_name }}
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="120">
            <template #default="scope">
              {{ getStatusText(scope.row.status_type) }}
            </template>
          </el-table-column>
          <el-table-column label="预约时间" width="180">
            <template #default="scope">
              {{ new Date(scope.row.appointment_time).toLocaleString() }}
            </template>
          </el-table-column>
          <el-table-column label="下单时间" width="180">
            <template #default="scope">
              {{ new Date(scope.row.create_datetime).toLocaleString() }}
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="120">
            <template #default="scope">
              <el-button
                  link
                  type="primary"
                  size="small"
                  @click="handleView(scope.row)"
              >
                查看详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-wrapper">
          <el-pagination
              v-model:current-page="searchField.page"
              v-model:page-size="searchField.limit"
              :page-sizes="[10, 20, 50, 100]"
              :total="orders.total"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>

    <!-- 工单详情 Dialog -->
    <el-dialog
        v-model="dialogVisible"
        title="工单详情"
        width="800px"
        :close-on-click-modal="false"
    >
      <div v-if="orderDetail" class="order-detail">
        <el-descriptions :column="2" border>
          <el-descriptions-item label="工单号">{{ orderDetail.order_number }}</el-descriptions-item>
          <el-descriptions-item label="状态">
            {{ getStatusText(orderDetail.status) }}
          </el-descriptions-item>
          <el-descriptions-item label="产品名称">
            {{ orderDetail.service_device?.brand_name + '-' + orderDetail.service_device?.model_name }}
          </el-descriptions-item>
          <el-descriptions-item label="设备编号">
            {{ orderDetail.service_device?.device_number || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="服务类型">{{ orderDetail.service_type || '-' }}</el-descriptions-item>
          <el-descriptions-item label="服务模式">{{ orderDetail.service_model || '-' }}</el-descriptions-item>
          <el-descriptions-item label="客户姓名">{{ orderDetail.client_name || '-' }}</el-descriptions-item>
          <el-descriptions-item label="联系电话">{{ orderDetail.client_telephone || '-' }}</el-descriptions-item>
          <el-descriptions-item label="预约时间" :span="2">
            {{ orderDetail.appointment_time ? new Date(orderDetail.appointment_time).toLocaleString() : '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="下单时间" :span="2">
            {{ orderDetail.create_datetime ? new Date(orderDetail.create_datetime).toLocaleString() : '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="服务地址" :span="2">
            {{ orderDetail.service_location_detail || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="故障描述" :span="2">
            {{ orderDetail.malfunction_desc || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="故障图片" :span="2" v-if="orderDetail.malfunction_attachments?.pictures?.length">
            <div class="image-list">
              <img
                  v-for="(img, index) in orderDetail.malfunction_attachments.pictures"
                  :key="index"
                  :src="img"
                  alt="故障图片"
                  class="detail-image"
                  @click="previewImage(img, orderDetail.malfunction_attachments.pictures)"
              />
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="故障视频" :span="2" v-if="orderDetail.malfunction_attachments?.videos?.length">
            <div class="video-list">
              <video
                  v-for="(video, index) in orderDetail.malfunction_attachments.videos"
                  :key="index"
                  :src="video"
                  controls
                  class="detail-video"
              />
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="订单金额" v-if="orderDetail.total_amount">
            {{ orderDetail.total_amount }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <template #footer>
        <el-button @click="dialogVisible = false">关闭</el-button>
      </template>
    </el-dialog>

    <!-- 图片预览 -->
    <Preview
        v-if="previewVisible"
        :data="previewList"
        :index="previewIndex"
        type="image"
        @close="previewVisible = false"
    />
  </div>
</template>
<style scoped>
.container {
  display: flex;
  background: #f5f6fa;
  min-height: calc(100vh - 11rem);
}

.content-wrapper {
  margin: auto;
  width: 90%;
  max-width: 1200px;
  padding: 2rem;
}

.page-header {
  text-align: center;
  margin-bottom: 2rem;
}

.page-header h1 {
  font-size: 2rem;
  font-weight: 600;
  margin: 0;
  color: #333;
}

.search-card {
  background: #fff;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.search-form {
  margin: 0;
}

.table-card {
  background: #fff;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.pagination-wrapper {
  margin-top: 1.5rem;
  display: flex;
  justify-content: flex-end;
}

.order-detail {
  padding: 1rem 0;
}

.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.detail-image {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #e0e0e0;
}

.detail-image:hover {
  border-color: #409eff;
}

.video-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.detail-video {
  width: 200px;
  max-height: 200px;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
}
</style>
<script setup>
import apiClient from "@/components/plugins/axios";
import {reactive, ref, onMounted} from "vue";
import {ElMessage} from 'element-plus';
import Preview from "@/components/templates/Preview.vue";

const loading = ref(false)
const dialogVisible = ref(false)
const previewVisible = ref(false)
const previewList = ref([])
const previewIndex = ref(0)
const orderDetail = ref(null)
const searchTimer = ref(null)

const searchField = reactive({
  order_number: null,//单号
  status_type: '',//状态
  page: 1,
  limit: 10
})
const orders = reactive({
  data: [],
  total: 0
})
const statusForm = [
  {value: '', label: '全部'},
  {value: 'PendingPay', label: '待支付'},
  {value: 'PendingServe', label: '待上门'},
  {value: 'Serving', label: '服务中'},
  {value: 'Completed', label: '已完成'},
  {value: 'Cancelled', label: '已取消'}
]

// 获取状态文本（将英文状态转换为中文）
function getStatusText(status) {
  // 根据 statusForm 数组查找对应的中文标签
  const statusItem = statusForm.find(item => item.value === status)
  return statusItem ? statusItem.label : status
}

// 获取工单列表
async function getOrder() {
  loading.value = true
  try {
    // 构建查询参数，过滤掉空值
    const params = {}
    if (searchField.order_number) {
      params.order_number = searchField.order_number
    }
    if (searchField.status_type) {
      params.status_type = searchField.status_type
    }
    params.page = searchField.page
    params.limit = searchField.limit

    const res = await apiClient.get('/api/v1/order/', {params})
    if (res.data.code === 200) {
      orders.data = res.data.data || []
      orders.total = res.data.count || 0
    } else {
      ElMessage.error(res.data.message || '获取工单列表失败')
    }
  } catch (error) {
    ElMessage.error('获取工单列表失败，请稍后重试')
  } finally {
    loading.value = false
  }
}

// 搜索（带防抖）
function handleSearch() {
  // 清除之前的定时器
  if (searchTimer.value) {
    clearTimeout(searchTimer.value)
  }
  // 设置新的定时器，延迟 500ms 执行
  searchTimer.value = setTimeout(() => {
    searchField.page = 1
    getOrder()
    searchTimer.value = null
  }, 500)
}

// 重置搜索
function handleReset() {
  searchField.order_number = null
  searchField.status = ""
  searchField.page = 1
  getOrder()
}

// 分页大小改变
function handleSizeChange(val) {
  searchField.limit = val
  searchField.page = 1
  getOrder()
}

// 当前页改变
function handleCurrentChange(val) {
  searchField.page = val
  getOrder()
}

// 查看详情
async function handleView(row) {
  try {
    const res = await apiClient.get('/api/v1/order/detail/' + row.id)
    if (res.data.code === 200) {
      orderDetail.value = res.data.data
      dialogVisible.value = true
    } else {
      ElMessage.error(res.data.message || '获取工单详情失败')
    }
  } catch (error) {
    console.error('获取工单详情失败:', error)
    ElMessage.error('获取工单详情失败，请稍后重试')
  }
}

// 预览图片
function previewImage(img, imgList) {
  previewList.value = imgList
  previewIndex.value = imgList.indexOf(img)
  previewVisible.value = true
}

onMounted(() => {
  getOrder()
})
</script>